var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"hidden":""}},[_c('Login'),_vm._v(" "),_c('glh-header'),_vm._v(" "),_c('section',{staticClass:"box"},[_c('nuxt')],1),_vm._v(" "),_c('glh-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }